import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { RootStoreContext } from '../../stores/rootStore';
import { observer } from 'mobx-react-lite';
import { saveVisit } from '../../api/visitTrackerService';

const RenewSuccess = () => {
    const rootStore = useContext(RootStoreContext);
    const { paymentId } = useParams();
    const orderStore = rootStore.orderStore;

    useEffect(() => {
        saveVisit('renew-success PaymentId: ' + paymentId);
        if (orderStore && paymentId !== undefined) {
            orderStore.checkRenewPayment(parseInt(paymentId));
        }
    }, [orderStore, paymentId]);

    return (
        <div className="page-wrap">
            {orderStore.order === undefined ? (
                <div className="page-center" style={{ flexDirection: 'column', gap: '16px' }}>
                    <div className="dcr-spinner" />
                    <p style={{ color: 'var(--muted)', fontSize: '.95rem' }}>Getting payment details…</p>
                </div>
            ) : orderStore.order?.error !== null ? (
                <div className="page-center">
                    <h1>Something went wrong</h1>
                    <p>{orderStore.order?.error}</p>
                </div>
            ) : (
                <div className="success-wrap">
                    <div className="result-icon renew-icon">
                        <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" width="30" height="30">
                            <path d="M21.5 2v6h-6"/><path d="M21.34 15.57a10 10 0 1 1-.57-8.38"/>
                        </svg>
                    </div>

                    <h1>Subscription renewed!</h1>
                    <p className="success-lede">
                        Your subscription has been extended and is now active until{' '}
                        <strong>{orderStore.order?.subscribtionEndDate}</strong>.
                        All existing activation codes remain the same — no reinstallation needed.
                    </p>

                    <div className="order-chip" style={{ '--chip-dot-bg': 'var(--accent)' } as React.CSSProperties}>
                        <span className="order-chip-dot" style={{ background: 'var(--accent)' }}>
                            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" width="13" height="13">
                                <polyline points="20,6 9,17 4,12"/>
                            </svg>
                        </span>
                        Renewal confirmed · Valid until <strong>{orderStore.order?.subscribtionEndDate}</strong>
                    </div>

                    <div className="steps">
                        <a href="/subscriptions" className="step-card">
                            <div className="step-icon">
                                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="20" height="20">
                                    <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M7 15h4"/>
                                </svg>
                            </div>
                            <div className="step-text">
                                <h3>Your subscriptions</h3>
                                <p>View licenses &amp; invoices</p>
                            </div>
                        </a>
                        <a href="https://desktopcallrecorder.com/manual" className="step-card">
                            <div className="step-icon">
                                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                                </svg>
                            </div>
                            <div className="step-text">
                                <h3>User manual</h3>
                                <p>Tips &amp; feature guides</p>
                            </div>
                        </a>
                    </div>

                    <p className="result-support">
                        Questions? Email <a href="mailto:team@desktopcallrecorder.com">team@desktopcallrecorder.com</a>
                    </p>
                </div>
            )}
        </div>
    );
};

export default observer(RenewSuccess);
